function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import '../assets/inputFields.css';
const TextAreaBox = _ref => {
  let {
    required = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(TextBox, _extends({
    multiline: true,
    required: required,
    rows: "5"
  }, rest));
};
TextAreaBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  placeholder: PropTypes.string
};
export default TextAreaBox;